<script setup lang="ts">
import { defineProps } from "vue";
import { useI18n } from "vue-i18n";
import { BodyAndStem } from "@/types/calculators";

defineProps<{
  bodyAndStem: BodyAndStem;
}>();

const { t } = useI18n();
</script>

<template>
  <div
    class="bg-white rounded-2xl border border-divider p-4 sm:p-6 shadow-sm space-y-4"
  >
    <div>
      <h2
        class="text-base sm:text-lg font-bold text-brown flex items-center gap-2"
      >
        <span>
          {{ t("calculators.personal-date.full-day-report.health.title") }}
        </span>
        <span class="text-xs font-normal text-muted font-caudex">
          (人神彭祖)
        </span>
      </h2>
      <p class="text-xs text-alternative-gray mt-0.5">
        {{ t("calculators.personal-date.full-day-report.health.subtitle") }}
      </p>
    </div>
    <div class="p-4 rounded-xl bg-beige border border-divider space-y-2">
      <div class="text-[11px] font-bold uppercase tracking-wider text-active">
        {{ t("calculators.personal-date.full-day-report.health.pengZuCanon") }}
      </div>
      <div class="text-base font-bold text-brown font-caudex">
        {{ bodyAndStem.peng_zu_bai_ji.combined_text }}
      </div>
      <ul class="text-xs text-alternative-gray space-y-1 pt-1">
        <li>
          •<strong class="text-brown">{{
            bodyAndStem.peng_zu_bai_ji.stem_taboo.clause
          }}</strong>
          {{ bodyAndStem.peng_zu_bai_ji.stem_taboo.ua }}
        </li>
        <li>
          •<strong class="text-brown">{{
            bodyAndStem.peng_zu_bai_ji.branch_taboo.clause
          }}</strong>
          {{ bodyAndStem.peng_zu_bai_ji.branch_taboo.ua }}
        </li>
      </ul>
    </div>
    <div class="p-4 rounded-xl bg-secondary border border-divider space-y-3">
      <div class="flex items-center justify-between">
        <span class="text-xs font-bold uppercase tracking-wide text-brown">
          {{
            t("calculators.personal-date.full-day-report.health.humanSpirit")
          }}
        </span>
      </div>
      <div class="space-y-2 text-xs">
        <div class="flex justify-between py-1 border-b border-divider">
          <span class="text-muted">
            {{
              t("calculators.personal-date.full-day-report.health.byLunarDay", {
                day: bodyAndStem.human_spirit_locations.lunar_day.day_number,
              })
            }}
          </span>
          <span class="font-bold text-brown">
            {{ bodyAndStem.human_spirit_locations.lunar_day.part_cn }}
            ({{ bodyAndStem.human_spirit_locations.lunar_day.part_ua }})
          </span>
        </div>
        <div class="flex justify-between py-1 border-b border-divider">
          <span class="text-muted">
            {{
              t("calculators.personal-date.full-day-report.health.byStem", {
                stem: bodyAndStem.human_spirit_locations.day_stem.stem,
              })
            }}
          </span>
          <span class="font-bold text-brown">
            {{ bodyAndStem.human_spirit_locations.day_stem.part_cn }}
            ({{ bodyAndStem.human_spirit_locations.day_stem.part_ua }})
          </span>
        </div>
        <div class="flex justify-between py-1 border-b border-divider">
          <span class="text-muted">
            {{
              t("calculators.personal-date.full-day-report.health.byBranch", {
                branch: bodyAndStem.human_spirit_locations.day_branch.branch,
              })
            }}
          </span>
          <span class="font-bold text-brown">
            {{ bodyAndStem.human_spirit_locations.day_branch.part_cn }}
            ({{ bodyAndStem.human_spirit_locations.day_branch.part_ua }})
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
